import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import "./Reports.css";
import host from "../config";
// const host = "http://13.203.79.3:3000";
// const host="https://api.vmrdarental.com";
// let host = "https://api.vmrdarental.com";

const UnifiedReports = () => {
  const navigate = useNavigate();
  const [subTotalSum, setSubTotalSum] = useState(0);
  const [selectedReport, setSelectedReport] = useState("booked"); // Default to "Booked"
  const [selectedFilter, setSelectedFilter] = useState("bookingDate");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [checkInStartDate, setCheckInStartDate] = useState(null);
  const [checkInEndDate, setCheckInEndDate] = useState(null);
  const [reportData, setReportData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [cancellationStartDate, setCancellationStartDate] = useState(null);
const [cancellationEndDate, setCancellationEndDate] = useState(null);


  const [currentPage, setCurrentPage] = useState(1);
const recordsPerPage = 10;






  useEffect(() => {
    if (
      !localStorage.getItem("access_token") ||
      localStorage.getItem("access_token") === ""
    ) {
      navigate("/", "_self");
    }
    // if (localStorage.getItem("userRole") !== "6") {
    //   navigate("/", "_self");
    // }

    const allowedRoles = ["1", "2", "3", "4", "5", "6", "7"];
  const userRole = localStorage.getItem("userRole");

  if (!allowedRoles.includes(userRole)) {
    navigate("/", "_self");
  }

    fetch(`${host}/sum-${selectedReport}-subtotal`)
      .then((response) => response.json())
      .then((data) => setSubTotalSum(data.total))
      .catch((error) =>
        console.error(`Error fetching ${selectedReport} sum:`, error)
      );
  }, [selectedReport]);

  // const fetchReportData = () => {
  //   const formattedStartDate = startDate
  //     ? moment(startDate).format("DD-MMM-YYYY")
  //     : "";
  //   const formattedEndDate = endDate
  //     ? moment(endDate).format("DD-MMM-YYYY")
  //     : "";
  //   const formattedCheckInStartDate = checkInStartDate
  //     ? moment(checkInStartDate).format("DD-MMM-YYYY")
  //     : "";
  //   const formattedCheckInEndDate = checkInEndDate
  //     ? moment(checkInEndDate).format("DD-MMM-YYYY")
  //     : "";

  //   let url = `${host}/api/${selectedReport}-bookings`;
  //   if (selectedFilter === "bookingDate" && startDate && endDate) {
  //     url += `?startBookingDate=${formattedStartDate}&endBookingDate=${formattedEndDate}`;
  //   } else if (
  //     selectedFilter === "checkInDate" &&
  //     checkInStartDate &&
  //     checkInEndDate
  //   ) {
  //     url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckInDate=${formattedCheckInEndDate}`;
  //   }

  //   fetch(url)
  //     .then((response) => response.json())
  //     .then((data) => setReportData(data))
  //     .catch((error) =>
  //       console.error(`Error fetching ${selectedReport} data:`, error)
  //     );
  // };


// const fetchReportData = () => {
//   // const formattedStartDate = startDate
//   //   ? moment(startDate).format("DD-MMM-YYYY")
//   //   : "";
//   // const formattedEndDate = endDate
//   //   ? moment(endDate).format("DD-MMM-YYYY")
//   //   : "";
//   // const formattedCheckInStartDate = checkInStartDate
//   //   ? moment(checkInStartDate).format("DD-MMM-YYYY")
//   //   : "";
//   // const formattedCheckInEndDate = checkInEndDate
//   //   ? moment(checkInEndDate).format("DD-MMM-YYYY")
//   //   : "";
//   // const formattedCancellationStartDate = cancellationStartDate
//   //   ? moment(cancellationStartDate).format("DD-MMM-YYYY")
//   //   : "";
//   // const formattedCancellationEndDate = cancellationEndDate
//   //   ? moment(cancellationEndDate).format("DD-MMM-YYYY")
//   //   : "";

//   const formattedStartDate = startDate
//   ? moment(startDate).format("YYYY-MM-DD")
//   : "";
// const formattedEndDate = endDate
//   ? moment(endDate).format("YYYY-MM-DD")
//   : "";
// const formattedCheckInStartDate = checkInStartDate
//   ? moment(checkInStartDate).format("YYYY-MM-DD")
//   : "";
// const formattedCheckInEndDate = checkInEndDate
//   ? moment(checkInEndDate).format("YYYY-MM-DD")
//   : "";
// const formattedCancellationStartDate = cancellationStartDate
//   ? moment(cancellationStartDate).format("YYYY-MM-DD")
//   : "";
// const formattedCancellationEndDate = cancellationEndDate
//   ? moment(cancellationEndDate).format("YYYY-MM-DD")
//   : "";


//   let url = `${host}/api/${selectedReport}-bookings`;

//   if (selectedFilter === "bookingDate" && startDate && endDate) {
//     url += `?startBookingDate=${formattedStartDate}&endBookingDate=${formattedEndDate}`;
//   } else if (
//     selectedFilter === "checkInDate" &&
//     checkInStartDate &&
//     checkInEndDate
//   ) {
//     url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckInDate=${formattedCheckInEndDate}`;
//   } else if (
//     selectedFilter === "cancellationDate" &&
//     cancellationStartDate &&
//     cancellationEndDate
//   ) {
//     url += `?startCancellationDate=${formattedCancellationStartDate}&endCancellationDate=${formattedCancellationEndDate}`;
//   }

//   fetch(url)
//     .then((response) => response.json())
//     .then((data) => setReportData(data))
//     .catch((error) =>
//       console.error(`Error fetching ${selectedReport} data:`, error)
//     );
// };

const fetchReportData = () => {
  const formattedStartDate = startDate
    ? moment(startDate).format("YYYY-MM-DD")
    : "";
  const formattedEndDate = endDate
    ? moment(endDate).format("YYYY-MM-DD")
    : "";
  const formattedCheckInStartDate = checkInStartDate
    ? moment(checkInStartDate).format("YYYY-MM-DD")
    : "";
  const formattedCheckInEndDate = checkInEndDate
    ? moment(checkInEndDate).format("YYYY-MM-DD")
    : "";
  const formattedCancellationStartDate = cancellationStartDate
    ? moment(cancellationStartDate).format("YYYY-MM-DD")
    : "";
  const formattedCancellationEndDate = cancellationEndDate
    ? moment(cancellationEndDate).format("YYYY-MM-DD")
    : "";

  let url = `${host}/api/${selectedReport}-bookings`;

  // ---------------- BOOKED REPORTS ----------------
  if (selectedReport === "booked") {
    if (selectedFilter === "bookingDate" && startDate && endDate) {
      url += `?startBookingDate=${formattedStartDate}&endBookingDate=${formattedEndDate}`;
    } else if (
      selectedFilter === "checkInDate" &&
      checkInStartDate &&
      checkInEndDate
    ) {
      url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckInDate=${formattedCheckInEndDate}`;
    }
  }

  // ---------------- BLOCKED REPORTS ----------------
  else if (selectedReport === "blocked") {
    if (selectedFilter === "bookingDate" && startDate && endDate) {
      // ✅ Fix: backend expects startBlockingDate, not startBookingDate
      url += `?startBlockingDate=${formattedStartDate}&endBlockingDate=${formattedEndDate}`;
    } else if (
      selectedFilter === "checkInDate" &&
      checkInStartDate &&
      checkInEndDate
    ) {
      url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckInDate=${formattedCheckInEndDate}`;
    }
  }

  // ---------------- CANCELLED REPORTS ----------------
  // else if (selectedReport === "cancelled") {
  //   if (
  //     selectedFilter === "cancellationDate" &&
  //     cancellationStartDate &&
  //     cancellationEndDate
  //   ) {
  //     url += `?startCancellationDate=${formattedCancellationStartDate}&endCancellationDate=${formattedCancellationEndDate}`;
  //   }
  // }

  // ---------------- CANCELLED REPORTS ----------------
else if (selectedReport === "cancelled") {

  if (selectedFilter === "bookingDate" && startDate && endDate) {
    url += `?startBookingDate=${formattedStartDate}&endBookingDate=${formattedEndDate}`;
  }

  else if (
    selectedFilter === "checkInDate" &&
    checkInStartDate &&
    checkInEndDate
  ) {
    url += `?startCheckInDate=${formattedCheckInStartDate}&endCheckInDate=${formattedCheckInEndDate}`;
  }

  else if (
    selectedFilter === "cancellationDate" &&
    cancellationStartDate &&
    cancellationEndDate
  ) {
    url += `?startCancellationDate=${formattedCancellationStartDate}&endCancellationDate=${formattedCancellationEndDate}`;
  }
}

  // Fetch data
  fetch(url)
    .then((response) => response.json())
    .then((data) => setReportData(data))
    .catch((error) =>
      console.error(`Error fetching ${selectedReport} data:`, error)
    );
};



  useEffect(() => {
    fetchReportData();
  }, [selectedReport, startDate, endDate, checkInStartDate, checkInEndDate]);

  const filteredData = reportData.filter((item) => {
    const values = Object.values(item).join(" ").toLowerCase();
    return values.includes(searchTerm.toLowerCase());
  });



const indexOfLastRecord = currentPage * recordsPerPage;
const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

const totalPages = Math.ceil(filteredData.length / recordsPerPage);

const goToPage = (page) => {
  if (page >= 1 && page <= totalPages) {
    setCurrentPage(page);
  }
};


  const calculateMonthlyTotals = () => {
    const totals = {};
    reportData.forEach((item) => {
      const month = moment(item.booking_time).format("YYYY-MM");
      if (!totals[month]) {
        totals[month] = { room_amount: 0, count: 0 };
      }
      totals[month].room_amount += item.room_amount;
      totals[month].count++;
    });
    return totals;
  };



  const downloadExcel = () => {
    const monthlyTotals = calculateMonthlyTotals();
    const dataWithTotals = [];
    let currentMonth = null;

    reportData.forEach((item) => {
      const month = moment(item.checkin_date).format("YYYY-MM");
      if (currentMonth !== month) {
        if (currentMonth && monthlyTotals[currentMonth]) {
          dataWithTotals.push({
            order_id: "",
            customer_name: "",
            room_name: "",
            checkin_date: "",
            room_amount: monthlyTotals[currentMonth].room_amount,
            address: "",
            pan_number: "",
            aadhaar_number: "",
            booking_time: "",
          });
        }
        currentMonth = month;
      }

      // Include only fields based on selected report
      const row = {};
      getTableFields().forEach((field) => {
        // row[field.key] = item[field.key];
        row[field.key] =
  field.key.toLowerCase().includes("date") ||
  field.key.toLowerCase().includes("time")
    ? formatDate(item[field.key])
    : item[field.key];
      });

      dataWithTotals.push(row);
    });

    const worksheet = XLSX.utils.json_to_sheet(dataWithTotals);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      `${selectedReport} Bookings`
    );
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `${selectedReport}_bookings.xlsx`);
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "px",
      format: "a4",
    });

    doc.setProperties({ title: `${selectedReport} Reports` });
    const headingText = `${selectedReport.charAt(0).toUpperCase() + selectedReport.slice(1)} Reports`;
    const fontSize = 18;
    const pageWidth = doc.internal.pageSize.getWidth();
    const textWidth =
      (doc.getStringUnitWidth(headingText) * fontSize) /
      doc.internal.scaleFactor;
    const textX = (pageWidth - textWidth) / 2;
    doc.setFontSize(fontSize);
    doc.text(headingText, textX, 40);

    const tableColumn = getTableFields().map((field) => field.label);
    const tableRows = [];

    const monthlyTotals = calculateMonthlyTotals();
    let currentMonth = null;

    reportData.forEach((item) => {
      const month = moment(item.booking_time).format("YYYY-MM");
      if (currentMonth !== month) {
        if (currentMonth && monthlyTotals[currentMonth]) {
          const totalRow = tableColumn.map(() => "");
          totalRow[tableColumn.indexOf("Room Amount")] =
            monthlyTotals[currentMonth].room_amount;
          tableRows.push(totalRow);
        }
        currentMonth = month;
      }

      const row = tableColumn.map((column) => {
        const field = getTableFields().find((f) => f.label === column);
        // return item[field ? field.key : column];
        const value = item[field ? field.key : column];

return field?.key?.toLowerCase().includes("date") ||
  field?.key?.toLowerCase().includes("time")
  ? formatDate(value)
  : value;
      });
      tableRows.push(row);
    });

    if (currentMonth && monthlyTotals[currentMonth]) {
      const totalRow = tableColumn.map(() => "");
      totalRow[tableColumn.indexOf("Room Amount")] =
        monthlyTotals[currentMonth].room_amount;
      tableRows.push(totalRow);
    }

    doc.autoTable(tableColumn, tableRows, { startY: 80 });
    doc.save(`${selectedReport}reports.pdf`);
  };

  const excludedFields = [
  "purpose",
  "booking_group_id",
  "room_id",
  "location_id",
  "customer_id",
  "payment_status",
  "id",
  "status",
  "attachment_url",
"blocked_by",
"is_blocked",
"booking_id",

  // add more if needed
];


  // const getTableFields = () => {
  //   if (selectedReport === "booked") {
  //     return [
  //       { key: "order_id", label: "Order ID" },
  //       { key: "customer_name", label: "Customer Name" },
  //       { key: "room_name", label: "Room Name" },
  //       { key: "checkin_date", label: "Check-in Date" },
  //       { key: "room_amount", label: "Room Amount" },
  //       { key: "address", label: "Address" },
  //       { key: "pan_number", label: "PAN Number" },
  //       { key: "aadhaar_number", label: "Aadhaar Number" },
  //       { key: "booking_time", label: "Booking Time" },
  //     ];
  //   } else if (selectedReport === "blocked") {
  //     return [
  //       // { key: "customer_name", label: "Customer Name" },
  //       { key: "room_name", label: "Venue Name" },
  //       { key: "checkin_date", label: "Check-in Date" },
  //       { key: "room_amount", label: "Room Amount" },
  //       { key: "created_ts", label: "Created Time" },
  //       { key: "block_reason", label: "Block Reason" },
  //       { key: "sub_total", label: "Sub Total" },
  //     ];
  //   } else if (selectedReport === "cancelled") {
  //     return [
  //       { key: "customer_id", label: "Customer id" },

  //       { key: "date", label: "Check-in Date" },
  //       { key: "room_amount", label: "Room Amount" },
  //       { key: "created_ts", label: "Created Time" },
  //       { key: "cancellation_reason", label: "Cancel Reason" },
  //       { key: "cancellation_date", label: "Cancel Date" },
  //       { key: "sub_total", label: "Sub Total" },
  //       { key: "order_id", label: "Order ID" },
  //       { key: "razorpay_order_id", label: "Razorpay Order ID" },
  //     ];
  //   }
  //   return [];
  // };
const getTableFields = () => {
  if (reportData.length === 0) return [];
  return Object.keys(reportData[0])
    .filter((key) => !excludedFields.includes(key))
  .map((key) => ({
    key,
    label: key.replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()),
  }));
};

// const formatDate = (value) => {
//   if (!value) return "";
//   // return moment(value).format("DD-MMM-YYYY");  
//   return moment(value).format("YYYY-MM-DD");

// };

const formatDate = (value) => {
  if (!value) return "";
  return moment(value).utcOffset("+05:30").format("YYYY-MM-DD");
};



  return (
    <div>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 content_back">
            <div className="row">
              <b className="text-center" style={{ fontSize: "20px" }}>
                VMRDA{" "}
                {selectedReport.charAt(0).toUpperCase() +
                  selectedReport.slice(1)}{" "}
                Reports
              </b>
            </div>

            <div className="filters">
              <label htmlFor="reportType">Select Report Type:</label>
              <select
                id="reportType"
                value={selectedReport}
                onChange={(e) => setSelectedReport(e.target.value)}
              >
                <option value="booked">Booked Reports</option>
                <option value="blocked">Blocked Reports</option>
                <option value="cancelled">Cancelled Reports</option>
              </select>
       


              <label htmlFor="filter">Filter By:</label>
              {/* <select
                id="filter"
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
              >
                <option value="bookingDate">Booking Date</option>
                <option value="checkInDate">Check-In Date</option>
              </select> */}

                     <select
  id="filter"
  value={selectedFilter}
  onChange={(e) => setSelectedFilter(e.target.value)}
>
  <option value="bookingDate">Booking Date</option>
  <option value="checkInDate">Check-In Date</option>
  {selectedReport === "cancelled" && (
    <option value="cancellationDate">Cancellation Date</option>
  )}
</select>

              {selectedFilter === "bookingDate" && (
                <>
                  <label>From:</label>
                  <DatePicker
                    selected={startDate}
                    onChange={(date) => setStartDate(date)}
                    selectsStart
                    startDate={startDate}
                    endDate={endDate}
                    // dateFormat="DD-MMM-YYYY"
                    dateFormat="yyyy-MM-dd"
                  />
                  <label>To:</label>
                  <DatePicker
                    selected={endDate}
                    onChange={(date) => setEndDate(date)}
                    selectsEnd
                    startDate={startDate}
                    endDate={endDate}
                    // dateFormat="DD-MMM-YYYY"
                    dateFormat="yyyy-MM-dd"
                  />
                </>
              )}

              {selectedFilter === "checkInDate" && (
                <>
                  <label>From Check-in:</label>
                  <DatePicker
                    selected={checkInStartDate}
                    onChange={(date) => setCheckInStartDate(date)}
                    selectsStart
                    startDate={checkInStartDate}
                    endDate={checkInEndDate}
                    // dateFormat="DD-MMM-YYYY"
                    dateFormat="yyyy-MM-dd"
                  />
                  <label>To Check-in:</label>
                  <DatePicker
                    selected={checkInEndDate}
                    onChange={(date) => setCheckInEndDate(date)}
                    selectsEnd
                    startDate={checkInStartDate}
                    endDate={checkInEndDate}
                    // dateFormat="DD-MMM-YYYY"
                    dateFormat="yyyy-MM-dd"
                  />
                </>
              )}

              {selectedFilter === "cancellationDate" && (
  <>
    <label>From Cancellation:</label>
    <DatePicker
      selected={cancellationStartDate}
      onChange={(date) => setCancellationStartDate(date)}
      selectsStart
      startDate={cancellationStartDate}
      endDate={cancellationEndDate}
      // dateFormat="DD-MMM-YYYY"
      dateFormat="yyyy-MM-dd"
    />
    <label>To Cancellation:</label>
    <DatePicker
      selected={cancellationEndDate}
      onChange={(date) => setCancellationEndDate(date)}
      selectsEnd
      startDate={cancellationStartDate}
      endDate={cancellationEndDate}
      // dateFormat="DD-MMM-YYYY"
      dateFormat="yyyy-MM-dd"
    />
  </>
)}


              <button className="btn-primary" onClick={fetchReportData}>
                Filter
              </button>
            </div>

            {/* <div className="search">
              <input
                type="text"
                placeholder="Search..."
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div> */}

            <div className="report-actions">
              <button className="btn-primary" onClick={downloadExcel}>
                Download Excel
              </button>
              <button
                className="btn-primary"
                onClick={downloadPDF}
                style={{ marginLeft: "10px" }}
              >
                Download PDF
              </button>
            </div>

          
            <table className="report-table table-responsive">
              {/* <thead>
                <tr>
                  {getTableFields().map((field) => (
                    <th key={field.key}>{field.label}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredData.map((item, index) => (
                  <tr key={index}>
                    {getTableFields().map((field) => (
                      <td key={field.key}>{item[field.key]}</td>
                    ))}
                  </tr>
                ))}
              </tbody> */}
              <thead>
  <tr>
    {getTableFields().map((field) => (
      <th key={field.key}>{field.label}</th>
    ))}
  </tr>
</thead>
<tbody style={{whiteSpace: "nowrap"}}>
  {currentRecords.map((item, index) => (
    <tr key={index}>
      {getTableFields().map((field) => (
        <td key={field.key}>
          {field.key.toLowerCase().includes("date") ||
          field.key.toLowerCase().includes("time")
            ? formatDate(item[field.key])
            : String(item[field.key] ?? "")}
        </td>
      ))}
    </tr>
  ))}
</tbody>


            </table>
          </div>
          <div className="pagination">
  {/** Pagination logic: show only 10 pages at a time **/}
  {(() => {
    const pagesPerGroup = 10;
    const currentGroup = Math.floor((currentPage - 1) / pagesPerGroup);
    const startPage = currentGroup * pagesPerGroup + 1;
    const endPage = Math.min(startPage + pagesPerGroup - 1, totalPages);

    return (
      <>
        <button
          className="btn-primary"
          onClick={() => goToPage(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Prev
        </button>

        {[...Array(endPage - startPage + 1)].map((_, i) => {
          const pageNum = startPage + i;
          return (
            <button
              key={pageNum}
              className={`btn-page ${currentPage === pageNum ? "active" : ""}`}
              onClick={() => goToPage(pageNum)}
            >
              {pageNum}
            </button>
          );
        })}

        <button
          className="btn-primary"
          onClick={() => goToPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </>
    );
  })()}
</div>

        </div>
      </div>
    </div>
  );
};

export default UnifiedReports;
